import React, { useEffect, useState } from 'react'
import { calcularEdad } from '../../../hooks/UseDate';
import { postTodosLosEstadosUser } from '../../../services/PaginaRuta';
import CambioDeEstadoCirugia from '../cambioDeEstado/CambioDeEstadoCirugia';
import CambioDeEstadoIngresoASala from '../cambioDeEstado/CambioDeEstadoIngresoASala';
import CambioDeEstadoPreparado from '../cambioDeEstado/CambioDeEstadoPreparado';
import CambioDeEstadoRecuperacion from '../cambioDeEstado/CambioDeEstadoRecuperacion';
import CambioDeEstadoSalida from '../cambioDeEstado/CambioDeEstadoSalida';
import ModalSeleccioneMedicoCirugia from "./ModalSeleccioneMedicoCirugia";
import CambioDeEstadoRealizada from '../cambioDeEstado/CambioDeEstadoRealizada';
import ModalImprimirPDFDescripcionQx from './ModalImprimirPDFDescripcionQx';
import ModalNotaInstrumentador from './Notas/ModalNotaInstrumentador';
import ModalMensajeNotas from './Notas/ModalMensajeNotas';
import ModalNotaAnestesiologo from './Notas/ModalNotaAnestesiologo';
import ModalImprimirPDFEspecialistas from './Notas/ModalImprimirPDFEspecialistas';

const TablaDescripcionQuirurgicaDQ = ({item,dataUserMedico,passDataActualizarDescripcionQX}) => {
    const usuarioInfo = JSON.parse(localStorage.getItem('usuarioInfo'));
    const [modalOnSeleccionMedicoCirugia, setmodalOnSeleccionMedicoCirugia]=useState(false)
    const [modalOnCambioEstadoIngresoSala, setmodalOnCambioEstadoIngresoSala]=useState(false)
    const [modalOnCambioEstadoPreparado, setmodalOnCambioEstadoPreparado]=useState(false)
    const [modalOnCambioEstadoCirugia,setmodalOnCambioEstadoCirugia]=useState(false)    
    const [modalOnCambioEstadoRecuperacion, setmodalOnCambioEstadoRecuperacion]=useState(false)
    const [modalOnCambioEstadoSalida, setmodalOnCambioEstadoSalida]=useState(false)
    const [modalOnCambioEstadoRealizada,setmodalOnCambioEstadoRealizada]=useState(false)
    const [cantidadCirujanos, setcantidadCirujanos]=useState(1)
    const [modalOnImprimir, setmodalOnImprimir]=useState(false)
    const [participanteInstrumentador, setparticipanteInstrumentador]=useState([])
    const [participanteAnestesiologo, setparticipanteAnestesiologo]=useState([])
    const [modalONInstrumentador, setmodalONInstrumentador]=useState(false)
    const [modalONAnestesiologo, setmodalONAnestesioLogo]=useState(false)
    const [mensajeNotas, setmensajeNotas]=useState('')
    const [dataInstrumentador, setdataInstrumentador]=useState({
      "MMNomM": "",
      "MENomE": "",
      "nota":""
    })
    const [dataAnestesiologo, setdataAnestesioLogo]=useState({
      "MMNomM": "",
      "MENomE": "",
      "nota":""
    })
    const [modalOnMensajeNotas, setmodalOnMensajeNotas]=useState(false)
    const [diseableCambioEstado, setdiseableCambioEstado]=useState({
      estadoPaciente:'2',
      disabledPendiente:false,
      disabledReservado:false,
      disabledConfirmado:false,
      disabledIngresoSala:false,
      disabledPreparado:false,
      disabledCirugia:false,
      disabledRecuperacion:false,
      disabledSalida:false,
      disabledCancelar:false,
      disabledRealizada:false,
      disabledFacturada:false
    })
    //data pdf
    const handleOnClickImprimir=()=>{      
      const arrayOtrosParticipantes = item.OtrosParticipantes
      //data intrumentador
      const instrumentador = arrayOtrosParticipantes.find(item => item.PersTip.trim() === "06");
      setdataInstrumentador(instrumentador? instrumentador:dataInstrumentador)
      //data anestesiologo
      const anestesiologo = arrayOtrosParticipantes.find(item => item.PersTip.trim() === "02");
      setdataAnestesioLogo(anestesiologo? anestesiologo:dataAnestesiologo)
      setmodalOnImprimir(true)
    }

    const passChildCambioDeEstado=(data)=>{
      setdiseableCambioEstado(data)
    }
    const handleOnclickSeleccionCirugia=()=>{
        setmodalOnSeleccionMedicoCirugia(true)
    }

    const handleOnClickNotaInstrumentador=()=>{      
      const arrayOtrosParticipantes = item.OtrosParticipantes      
      if(arrayOtrosParticipantes.length > 0){        
        const instrumentador = arrayOtrosParticipantes.find(item => item.PersTip.trim() === "06");        
        if(instrumentador){
          if(usuarioInfo.Codigo_medico.trim() === instrumentador.PersCod.trim()){
            setmodalONInstrumentador(true)          
            setdataInstrumentador(instrumentador)
          }else{
            setmodalOnMensajeNotas(true)
            setmensajeNotas('El Usuario con el cual ingreso al sistema no corresponde al médico seleccionado para realizar la Nota Instrumentador')
          }
          
        }else{
          setmodalOnMensajeNotas(true)
          setmensajeNotas('Debe seleccionar un Instrumentador para poder continuar')
        } 
      }else{
        setmodalOnMensajeNotas(true)
        setmensajeNotas('Debe seleccionar un Instrumentador y un Anestesiólogo para poder continuar')
      }
    }

    const handleOnClickNotaAnestesiologo=()=>{      
      const arrayOtrosParticipantes = item.OtrosParticipantes      
      if(arrayOtrosParticipantes.length > 0){        
        const anestesiologo = arrayOtrosParticipantes.find(item => item.PersTip.trim() === "02");
        if(anestesiologo){
          if(usuarioInfo.Codigo_medico.trim() === anestesiologo.PersCod.trim()){
            setmodalONAnestesioLogo(true)
            setdataAnestesioLogo(anestesiologo)
          }else{
            setmodalOnMensajeNotas(true)
            setmensajeNotas('El Usuario con el cual ingreso al sistema no corresponde al médico seleccionado para realizar la Nota Anestesiólogo')
          }
          
        }else{
          setmodalOnMensajeNotas(true)
          setmensajeNotas('Debe seleccionar un Anestesiólogo para poder continuar')
        }        
      }else{
        setmodalOnMensajeNotas(true)
        setmensajeNotas('Debe seleccionar un Instrumentador y un Anestesiólogo para poder continuar')
      }
    }

    const handleOnchangeCambiarEstado=(e)=>{
      e.preventDefault();
      if(e.target.value === "11"){
        setmodalOnCambioEstadoIngresoSala(true)
      }
      if(e.target.value === "12"){
        setmodalOnCambioEstadoPreparado(true)
      }
      if(e.target.value === "13"){
        setmodalOnCambioEstadoCirugia(true)
      }
      if(e.target.value === "15"){
        setmodalOnCambioEstadoRecuperacion(true)
      }
      if(e.target.value === "14"){
        setmodalOnCambioEstadoSalida(true)
      }
      if(e.target.value === "4"){
        setmodalOnCambioEstadoRealizada(true)
      }
    }
    
    useEffect(()=>{
      // Filtrar a un solo participante por tipo
      const participanteInstrumentador = item.OtrosParticipantes?.find(p => p.PersTip?.trim() === "06");
      setparticipanteInstrumentador(participanteInstrumentador)
      const participanteAnestesiologo = item.OtrosParticipantes?.find(p => p.PersTip?.trim() === "02");
      setparticipanteAnestesiologo(participanteAnestesiologo)

      
      if(item.ProPerSe1 && item.ProPerSe2){
        setcantidadCirujanos(2)
      }
      

      if(item.ProEsta === '6'){
              setdiseableCambioEstado({
                estadoPaciente:'6',
                disabledPendiente:true,
                disabledReservado:false,
                disabledConfirmado:true,
                disabledIngresoSala:true,
                disabledPreparado:true,
                disabledCirugia:true,
                disabledRecuperacion:true,
                disabledSalida:true,
                disabledCancelar:true,
                disabledRealizada:true,
                disabledFacturada:true
              })
              //setmodalOnCambioEstadoCancelar(true)
      }else if(item.ProEsta === '3'){
        setdiseableCambioEstado({
          estadoPaciente:'3',
          disabledPendiente:true,
          disabledReservado:true,
          disabledConfirmado:true,
          disabledIngresoSala:true,
          disabledPreparado:true,
          disabledCirugia:true,
          disabledRecuperacion:true,
          disabledSalida:true,
          disabledCancelar:true,
          disabledRealizada:true,
          disabledFacturada:true
        })
      }else if(item.ProEsta === '4'){
        setdiseableCambioEstado({
          estadoPaciente:'4',
          disabledPendiente:true,
          disabledReservado:true,
          disabledConfirmado:true,
          disabledIngresoSala:true,
          disabledPreparado:true,
          disabledCirugia:true,
          disabledRecuperacion:true,
          disabledSalida:true,
          disabledCancelar:true,
          disabledRealizada:true,
          disabledFacturada:true
        })
          //setmodalOnCambioEstadoCancelar(false)
      }
       else if(item.ultimoEstado ==='reservado' ){
            setdiseableCambioEstado({
              estadoPaciente:'1',
              disabledPendiente:true,
              disabledReservado:true,
              disabledConfirmado:false,
              disabledIngresoSala:true,
              disabledPreparado:true,
              disabledCirugia:true,
              disabledRecuperacion:true,
              disabledSalida:true,
              disabledCancelar:false,
              disabledRealizada:true,
              disabledFacturada:true
            })
            //setmodalOnCambioEstadoCancelar(false)
      }else if(item.ultimoEstado ==='confirmado'){
            setdiseableCambioEstado({
              estadoPaciente:'2',
              disabledPendiente:true,
              disabledReservado:true,
              disabledConfirmado:true,
              disabledIngresoSala:false,
              disabledPreparado:true,
              disabledCirugia:true,
              disabledRecuperacion:true,
              disabledSalida:true,
              disabledCancelar:false,
              disabledRealizada:true,
              disabledFacturada:true
            })
              //setmodalOnCambioEstadoCancelar(false)
      }else if(item.ultimoEstado ==='ingreso a sala'){
              setdiseableCambioEstado({
                estadoPaciente:'11',
                disabledPendiente:true,
                disabledReservado:true,
                disabledConfirmado:true,
                disabledIngresoSala:true,
                disabledPreparado:false,
                disabledCirugia:true,
                disabledRecuperacion:true,
                disabledSalida:true,
                disabledCancelar:true,
                disabledRealizada:true,
                disabledFacturada:true
              })
              //setmodalOnCambioEstadoCancelar(true)
      }else if(item.ultimoEstado ==='preparado'){
              setdiseableCambioEstado({
                estadoPaciente:'12',
                disabledPendiente:true,
                disabledReservado:true,
                disabledConfirmado:true,
                disabledIngresoSala:true,
                disabledPreparado:true,
                disabledCirugia:false,
                disabledRecuperacion:true,
                disabledSalida:true,
                disabledCancelar:true,
                disabledRealizada:true,
                disabledFacturada:true
              })
              //setmodalOnCambioEstadoCancelar(true)
      }else if(item.ultimoEstado ==='cirugia'){
              setdiseableCambioEstado({
                estadoPaciente:'13',
                disabledPendiente:true,
                disabledReservado:true,
                disabledConfirmado:true,
                disabledIngresoSala:true,
                disabledPreparado:true,
                disabledCirugia:true,
                disabledRecuperacion:false,
                disabledSalida:true,
                disabledCancelar:true,
                disabledRealizada:true,
                disabledFacturada:true
              })
              //setmodalOnCambioEstadoCancelar(true)
      }else if(item.ultimoEstado ==='recuperacion'){
              setdiseableCambioEstado({
                estadoPaciente:'15',
                disabledPendiente:true,
                disabledReservado:true,
                disabledConfirmado:true,
                disabledIngresoSala:true,
                disabledPreparado:true,
                disabledCirugia:true,
                disabledRecuperacion:true,
                disabledSalida:false,
                disabledCancelar:true,
                disabledRealizada:true,
                disabledFacturada:true
              })
              
      }else if(item.ultimoEstado ==='salida'){
              setdiseableCambioEstado({
                estadoPaciente:'14',
                disabledPendiente:true,
                disabledReservado:true,
                disabledConfirmado:true,
                disabledIngresoSala:true,
                disabledPreparado:true,
                disabledCirugia:true,
                disabledRecuperacion:true,
                disabledSalida:true,
                disabledCancelar:true,
                disabledRealizada:false,
                disabledFacturada:true
              })
              //setmodalOnCambioEstadoCancelar(true)
      }
      /////estados quemados
      else if(item.ProEsta === '1'){
        setdiseableCambioEstado({
          estadoPaciente:'1',
          disabledPendiente:true,
          disabledReservado:true,
          disabledConfirmado:false,
          disabledIngresoSala:true,
          disabledPreparado:true,
          disabledCirugia:true,
          disabledRecuperacion:true,
          disabledSalida:true,
          disabledCancelar:false,
          disabledRealizada:true,
          disabledFacturada:true
        })
        //setmodalOnCambioEstadoCancelar(false)
      }
      else if(item.ProEsta === '7'){
        setdiseableCambioEstado({
          estadoPaciente:'1',
          disabledPendiente:true,
          disabledReservado:true,
          disabledConfirmado:false,
          disabledIngresoSala:true,
          disabledPreparado:true,
          disabledCirugia:true,
          disabledRecuperacion:true,
          disabledSalida:true,
          disabledCancelar:false,
          disabledRealizada:true,
          disabledFacturada:true
        })
        //setmodalOnCambioEstadoCancelar(false)
      }else if(item.ProEsta === '2'){
        setdiseableCambioEstado({
          estadoPaciente:'2',
          disabledPendiente:true,
          disabledReservado:true,
          disabledConfirmado:true,
          disabledIngresoSala:false,
          disabledPreparado:true,
          disabledCirugia:true,
          disabledRecuperacion:true,
          disabledSalida:true,
          disabledCancelar:false,
          disabledRealizada:true,
          disabledFacturada:true
        })
          //setmodalOnCambioEstadoCancelar(false)
      }
      else if(item.ProEsta === '5'){
        setdiseableCambioEstado({
          estadoPaciente:'5',
          disabledPendiente:true,
          disabledReservado:true,
          disabledConfirmado:true,
          disabledIngresoSala:true,
          disabledPreparado:true,
          disabledCirugia:true,
          disabledRecuperacion:true,
          disabledSalida:true,
          disabledCancelar:true,
          disabledRealizada:true,
          disabledFacturada:true
        })
        //setmodalOnCambioEstadoCancelar(true)
      }else if(item.ProEsta === '8'){
        setdiseableCambioEstado({
          estadoPaciente:'6',
                disabledPendiente:true,
                disabledReservado:false,
                disabledConfirmado:true,
                disabledIngresoSala:true,
                disabledPreparado:true,
                disabledCirugia:true,
                disabledRecuperacion:true,
                disabledSalida:true,
                disabledCancelar:true,
                disabledRealizada:true,
                disabledFacturada:true
        })
        //setmodalOnCambioEstadoCancelar(true)
      }
      
      
    },[item.ProCirCod])

  return (
    <>
    <tbody>
    <tr className={('4' === item.ProEsta)?"divide-y divide-slate-700 bg-[#a7f3d0]":"divide-y divide-slate-700 "}>
        <td></td>
          
          <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap">
            
            <div className="">
                    <button
                      onClick={handleOnclickSeleccionCirugia}
                      type="button"
                      className="inline-block px-2 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out"
                    >
                      Quirúrgica
                    </button>
            </div>
          </td>
        <>
  {/* Celda: Instrumentador */}
  <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap">
    {
      participanteInstrumentador ? (
        
          <button
            onClick={handleOnClickNotaInstrumentador}
            type="button"
            className="inline-block px-2 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out"
          >
            Instrumentador
          </button>
          
        
      ) : null
    }
  </td>

  {/* Celda: Anestesiólogo */}
  <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap">
    {
      participanteAnestesiologo ? (
        
          <button
            onClick={handleOnClickNotaAnestesiologo}
            type="button"
            className="inline-block px-2 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out"
          >
            Anestesiólogo
          </button>
          
        
      ) : null
    }
  </td>
</>



          
          
          {/* {
            ('4' === item.ProEsta)? */}
            <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap">
            
            <div className="">
                    <button
                      onClick={handleOnClickImprimir}
                      type="button"
                      className="inline-block px-2 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out"
                    >
                      Imprimir
                    </button>
            </div>
          </td>
          
          
          
          <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap">
            {item.ProCirCod}
          </td>
          <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap">
           {item.ProFec? item.ProFec.split(' ')[0]:null}
          </td>
          <td className="text-xs text-gray-900 font-medium px-3 py-2 text-left whitespace-pre-wrap">
            {item.ProCons}
          </td>
          <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap">
            {item.ProNcons}
          </td>
          <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap text-left">
            {item.MPCedu}
          </td>
          <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap ">
            {item.MPTDoc}
          </td>
          <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap ">
           
           {item.MPFchN? calcularEdad(item.MPFchN.split(' ')[0]):null}
          </td>
          <td className="text-xs text-gray-900 font-medium px-6 py-4 whitespace-pre-wrap ">
            {item.ProCtvIn}
          </td>
          <td className="text-xs text-gray-900 font-medium px-6 py-4 whitespace-pre-wrap text-left">
            {item.MPNOMC}
            


          </td>
          <td className="text-xs text-gray-900 font-medium  whitespace-pre-wrap text-left">
            
            <div className="flex items-center space-x-2">
            {
              item.descripcionQxDiligenciada.map((procedimiento, index)=>(
                procedimiento.DescripcionQx?
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="24px" height="56px" fill="black">
              
              <path d="M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-96 55.2C54 332.9 0 401.3 0 482.3C0 498.7 13.3 512 29.7 512H418.3c16.4 0 29.7-13.3 29.7-29.7c0-81-54-149.4-128-171.1V362c27.6 7.1 48 32.2 48 62v40c0 8.8-7.2 16-16 16H336c-8.8 0-16-7.2-16-16s7.2-16 16-16V424c0-17.7-14.3-32-32-32s-32 14.3-32 32v24c8.8 0 16 7.2 16 16s-7.2 16-16 16H256c-8.8 0-16-7.2-16-16V424c0-29.8 20.4-54.9 48-62V304.9c-6-.6-12.1-.9-18.3-.9H178.3c-6.2 0-12.3 .3-18.3 .9v65.4c23.1 6.9 40 28.3 40 53.7c0 30.9-25.1 56-56 56s-56-25.1-56-56c0-25.4 16.9-46.8 40-53.7V311.2zM144 448a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"/>
              </svg>
              :
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="24px" height="56px" fill="#808080">
              
              <path d="M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-96 55.2C54 332.9 0 401.3 0 482.3C0 498.7 13.3 512 29.7 512H418.3c16.4 0 29.7-13.3 29.7-29.7c0-81-54-149.4-128-171.1V362c27.6 7.1 48 32.2 48 62v40c0 8.8-7.2 16-16 16H336c-8.8 0-16-7.2-16-16s7.2-16 16-16V424c0-17.7-14.3-32-32-32s-32 14.3-32 32v24c8.8 0 16 7.2 16 16s-7.2 16-16 16H256c-8.8 0-16-7.2-16-16V424c0-29.8 20.4-54.9 48-62V304.9c-6-.6-12.1-.9-18.3-.9H178.3c-6.2 0-12.3 .3-18.3 .9v65.4c23.1 6.9 40 28.3 40 53.7c0 30.9-25.1 56-56 56s-56-25.1-56-56c0-25.4 16.9-46.8 40-53.7V311.2zM144 448a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"/>
              </svg>
              ))
            }
            </div>

          </td>
          
        </tr> 
        </tbody>
        {modalOnSeleccionMedicoCirugia? <ModalSeleccioneMedicoCirugia setmodalOnSeleccionMedicoCirugia={setmodalOnSeleccionMedicoCirugia} item={item} passChildCambioDeEstado={passChildCambioDeEstado} dataUserMedico={dataUserMedico} passDataActualizarDescripcionQX={passDataActualizarDescripcionQX}/>:null}
        {modalOnCambioEstadoIngresoSala? <CambioDeEstadoIngresoASala setmodalOnCambioEstadoIngresoSala={setmodalOnCambioEstadoIngresoSala} user={item} passChildCambioDeEstado={passChildCambioDeEstado}/>:null }
        {modalOnCambioEstadoPreparado? <CambioDeEstadoPreparado setmodalOnCambioEstadoPreparado={setmodalOnCambioEstadoPreparado} user={item} passChildCambioDeEstado={passChildCambioDeEstado}/>:null}
        {modalOnCambioEstadoCirugia? <CambioDeEstadoCirugia setmodalOnCambioEstadoCirugia={setmodalOnCambioEstadoCirugia} user={item} passChildCambioDeEstado={passChildCambioDeEstado}/>:null}
        {modalOnCambioEstadoRecuperacion? <CambioDeEstadoRecuperacion setmodalOnCambioEstadoRecuperacion={setmodalOnCambioEstadoRecuperacion} user={item} passChildCambioDeEstado={passChildCambioDeEstado}/>:null}
        {modalOnCambioEstadoSalida? <CambioDeEstadoSalida setmodalOnCambioEstadoSalida={setmodalOnCambioEstadoSalida} user={item} passChildCambioDeEstado={passChildCambioDeEstado}/>:null}
        {modalOnCambioEstadoRealizada? <CambioDeEstadoRealizada setmodalOnCambioEstadoRealizada={setmodalOnCambioEstadoRealizada} user={item} passChildCambioDeEstado={passChildCambioDeEstado}/>:null}
        {/* {modalOnImprimir? <ModalImprimirPDFDescripcionQx setmodalOnImprimir={setmodalOnImprimir} item={item}/>:null} */}
        {modalOnImprimir && <ModalImprimirPDFEspecialistas setmodalOnImprimir={setmodalOnImprimir} user={item} dataInstrumentador={dataInstrumentador} dataAnestesiologo={dataAnestesiologo}/>}
        {modalONInstrumentador && <ModalNotaInstrumentador setmodalONInstrumentador={setmodalONInstrumentador} dataInstrumentador={dataInstrumentador} user={item} passDataActualizarDescripcionQX={passDataActualizarDescripcionQX}/>}
        {modalOnMensajeNotas && <ModalMensajeNotas setmodalOnMensajeNotas={setmodalOnMensajeNotas} mensajeNotas={mensajeNotas}/>}
        {modalONAnestesiologo && <ModalNotaAnestesiologo setmodalONAnestesioLogo={setmodalONAnestesioLogo} dataAnestesiologo={dataAnestesiologo} user={item} passDataActualizarDescripcionQX={passDataActualizarDescripcionQX}/>}
        </>  
  )
}

export default TablaDescripcionQuirurgicaDQ